module.exports = __webpack_public_path__ + "img/close-eye.caf29f1a.svg";